import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { clsx, withSpacing } from '@wds/utils';
import { SEMANTIC_COLORS, TYPE_COLORS } from '@wds/helpers';

import { useTheme } from 'react-jss';

import useStyles from './useStyles';

export const ALIGNMENT = ['center', 'left', 'right'];

export const VARIANTS = [
  'body',
  'bodySm',
  'cardTitle',
  'hero1',
  'hero2',
  'link',
  'pageTitle',
  'sectionTitle',
];

// @todo: custom components wanted like <Link />??
export const COMPONENT_LIST = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'a',
  'p',
  'span',
  'div',
  'article',
  'section',
];

const Typography = forwardRef(
  ({ align, className, children, color, component, variant, ...rest }, ref) => {
    const Component = component;
    const theme = useTheme();
    const classes = useStyles({ align, color, variant, theme });
    const classNames = clsx(className, classes.wdsTypography);
    return (
      <Component className={classNames} {...rest} ref={ref}>
        {children}
      </Component>
    );
  }
);

Typography.propTypes = {
  /**
   * Align content
   */
  align: PropTypes.oneOf(ALIGNMENT),
  /**
   * Text content to be displayed
   */
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  /**
   * Color variants
   */
  color: PropTypes.oneOf(SEMANTIC_COLORS.concat(TYPE_COLORS)),
  /**
   * Must be one of the following components:
   */
  component: PropTypes.oneOf(COMPONENT_LIST),
  /**
   * Our variants of choice are:
   */
  variant: PropTypes.oneOf(VARIANTS),
};

Typography.defaultProps = {
  align: 'left',
  className: undefined,
  component: 'div',
  color: 'dark',
  variant: 'body',
};

const TypographyWithSpacing = withSpacing(Typography);

TypographyWithSpacing.displayName = 'Typography';

export default TypographyWithSpacing;
